import { Button, Col, Input, Row } from "reactstrap";
import { SelectsFiltrosCuadrosTurnosProvider } from "../../../../store/selects-filtros-cuadros-turnos-context";
import SelectFiltroTurno from "./select-filtro-turno";
import SelectSedesAreasLider from "./select-sedes-areas-lider";
import SelectSubAreasLider from "./select-sub-areas-lider";
import { validarRangoDeFecha } from "../../../../helpers/cuadro-turnos-helper";
import { toast } from "../../../../../../core/helpers/message-helper";
import DateRangePicker from "../../../../../../core/ui/components/DateRangePicker";
import useDebounce from "../../../../../../core/hooks/use-debounce";
import { useState } from "react";
import { useEffect } from "react";
import CuadroTurnosContext from "../../../../store/cuadro-turnos-context";
import { useContext } from "react";

const FiltrosCuadrosTurnos = () => {
    const {
        setFiltros,
        filtros,
        setDataCuadroTurnos,
        allDataCuadroTurnos,
        getCuadroTurnos,
    } = useContext(CuadroTurnosContext);
    const [searchTerm, setSearchTerm] = useState("");
    const [mostrarFiltros, setMostrarFiltros] = useState(true);
    const debounce = useDebounce(searchTerm, 700);

    const onChangeDateRange = function (inicio, fin) {
        const fechaInicio = inicio.format("YYYY-MM-DD");
        const fechaFin = fin.format("YYYY-MM-DD");
        const diasMaximos = 35;
        const esRangoValido = validarRangoDeFecha(
            fechaInicio,
            fechaFin,
            diasMaximos
        );

        if (!esRangoValido) {
            return toast.error(
                `El rango de fecha no puede ser mayor a ${diasMaximos} días`
            );
        }

        setFiltros((prev) => {
            return { ...prev, startDate: fechaInicio, endDate: fechaFin };
        });
    };

    useEffect(() => {
        if (!debounce) {
            return setDataCuadroTurnos((prev) => {
                return { ...prev, cuadroTurnos: allDataCuadroTurnos };
            });
        }

        const regexp = new RegExp(debounce, "ig");
        const allDataCuadroTurnosCopia = structuredClone(allDataCuadroTurnos);
        const busquedaPersonas = allDataCuadroTurnosCopia.filter((subArea) => {
            const personas = subArea.personas.filter((persona) => {
                return (
                    regexp.test(persona.nombres) ||
                    regexp.test(persona.documento)
                );
            });
            subArea.personas = personas;
            return personas.length > 0;
        });

        setDataCuadroTurnos((prev) => {
            return { ...prev, cuadroTurnos: busquedaPersonas };
        });
    }, [debounce]);

    const onMostrarFiltros = () => {
        setMostrarFiltros((prev) => !prev);
    };

    return (
        <div
            className="border p-2 mb-2 d-flex"
            style={{
                borderTopLeftRadius: "15px",
                paddingTop: "8px",
                paddingLeft: "8px",
                paddingRight: "8px",
                paddingBottom: !mostrarFiltros ? "8px" : 0,
            }}
        >
            <Button
                onClick={onMostrarFiltros}
                size="sm"
                color="grey"
                className="text-center border-circular d-flex justify-content-center align-items-center mr-5"
                style={{ width: "20px", height: "20px", fontSize: "10px" }}
            >
                <i
                    className={`fas ${
                        mostrarFiltros ? "fa-eye-slash" : "fa-eye"
                    }`}
                ></i>
            </Button>
            <SelectsFiltrosCuadrosTurnosProvider>
                {mostrarFiltros && (
                    <Row className="w-100">
                        <Col lg={10}>
                            <Row className="d-flex align-items-center">
                                <Col lg={2} className="mb-2">
                                    <label className="mt-2">
                                        <i className="fas fa-calendar-alt"></i>{" "}
                                        Rango de Fechas
                                    </label>
                                    <DateRangePicker
                                        id="cuadroTurnoFecha"
                                        endDate={filtros.endDate}
                                        startDate={filtros.startDate}
                                        onChangeRange={onChangeDateRange}
                                    />
                                </Col>

                                <Col lg={3}>
                                    <SelectSedesAreasLider />
                                </Col>
                                <Col lg={3}>
                                    <SelectSubAreasLider />
                                </Col>
                                <Col lg={2}>
                                    <SelectFiltroTurno />
                                </Col>
                                <Col lg={2}>
                                    <Button
                                        color="primary"
                                        onClick={() => getCuadroTurnos()}
                                    >
                                        <i className="fas fa-search"></i>{" "}
                                        Filtrar
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={2}>
                            <label className="mt-2">
                                <i className="fas fa-search"></i> Buscar...
                            </label>
                            <Input
                                type="text"
                                value={searchTerm ?? ""}
                                id="buscarCuadroTurno"
                                name="buscarCuadroTurno"
                                placeholder="Buscar colaborador..."
                                onInput={(event) => {
                                    setSearchTerm(event.target.value);
                                }}
                            />
                        </Col>
                    </Row>
                )}
            </SelectsFiltrosCuadrosTurnosProvider>
        </div>
    );
};

export default FiltrosCuadrosTurnos;
